import { useEffect, useState } from "react";

const Check = ({ label, checked, onChange, id }) => (
  <label className="flex min-h-[40px] cursor-pointer items-center gap-3 text-sm text-gray-300 hover:text-white">
    <input type="checkbox" checked={checked} onChange={onChange} className="h-5 w-5 accent-[#D4AF37]" data-testid={id} />
    {label}
  </label>
);

const Group = ({ title, children }) => (
  <fieldset className="border-b border-line py-5 first:pt-0">
    <legend className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-gray-400">{title}</legend>
    {children}
  </fieldset>
);

const toggleList = (csv, v) => {
  const set = new Set((csv || "").split(",").filter(Boolean));
  set.has(v) ? set.delete(v) : set.add(v);
  return [...set].join(",");
};

export const Filters = ({ facets, sp, set, hideSale }) => {
  const [min, setMin] = useState(sp.get("min_price") || "");
  const [max, setMax] = useState(sp.get("max_price") || "");
  useEffect(() => { setMin(sp.get("min_price") || ""); setMax(sp.get("max_price") || ""); }, [sp]);
  if (!facets) return null;
  const active = ["brand", "strain", "min_price", "max_price", "in_stock", "on_sale"].some((k) => sp.get(k));
  return (
    <div data-testid="filters-panel">
      {facets.strains.length > 0 && (
        <Group title="Strain type">
          {facets.strains.map((s) => <Check key={s} label={s} id={`filter-strain-${s.toLowerCase()}`} checked={(sp.get("strain") || "").split(",").includes(s)} onChange={() => set("strain", toggleList(sp.get("strain"), s))} />)}
        </Group>
      )}
      {facets.brands.length > 0 && (
        <Group title="Brand">
          <div className="max-h-64 overflow-y-auto pr-2">
            {facets.brands.map((b) => <Check key={b} label={b} id={`filter-brand-${b.toLowerCase().replace(/\W+/g, "-")}`} checked={(sp.get("brand") || "").split(",").includes(b)} onChange={() => set("brand", toggleList(sp.get("brand"), b))} />)}
          </div>
        </Group>
      )}
      <Group title="Price">
        <form className="flex items-center gap-2" onSubmit={(e) => { e.preventDefault(); set({ min_price: min, max_price: max }); }}>
          <label className="sr-only" htmlFor="f-min">Minimum price</label>
          <input id="f-min" inputMode="decimal" value={min} onChange={(e) => setMin(e.target.value)} placeholder={`$${Math.floor(facets.price_min)}`} className="h-11 w-full rounded-xl border border-line bg-ink px-3 text-sm" data-testid="filter-min-price" />
          <span className="text-gray-500">–</span>
          <label className="sr-only" htmlFor="f-max">Maximum price</label>
          <input id="f-max" inputMode="decimal" value={max} onChange={(e) => setMax(e.target.value)} placeholder={`$${Math.ceil(facets.price_max)}`} className="h-11 w-full rounded-xl border border-line bg-ink px-3 text-sm" data-testid="filter-max-price" />
          <button type="submit" className="h-11 rounded-xl border border-line px-3 text-sm font-semibold text-gold hover:border-gold" data-testid="filter-price-apply">Go</button>
        </form>
      </Group>
      <Group title="Availability">
        <Check label={`In stock only (${facets.in_stock})`} id="filter-in-stock" checked={sp.get("in_stock") === "true"} onChange={() => set("in_stock", sp.get("in_stock") === "true" ? "" : "true")} />
        {!hideSale && facets.on_sale > 0 && <Check label={`On sale (${facets.on_sale})`} id="filter-on-sale" checked={sp.get("on_sale") === "true"} onChange={() => set("on_sale", sp.get("on_sale") === "true" ? "" : "true")} />}
      </Group>
      {active && <button type="button" onClick={() => set({ brand: "", strain: "", min_price: "", max_price: "", in_stock: "", on_sale: "" })} className="link-gold mt-5 text-sm" data-testid="filters-clear-button">Clear all filters</button>}
    </div>
  );
};

export const SORT_OPTIONS = [
  ["featured", "Featured"], ["newest", "Newest"], ["price-asc", "Price: Low to High"], ["price-desc", "Price: High to Low"], ["name", "Name A–Z"], ["discount", "Biggest Discount"],
];
